import { List } from "@mui/material";
import { useTranslation } from "common/locales";
import { FileEntry } from "model";
import FileEntryListItem from "./FileEntryListItem";
export default function FileEntryList({
  fileEntries: sortedFileEntries,
}: {
  fileEntries: Array<FileEntry>;
}) {
  const { t } = useTranslation();

  return (
    <List>
      {sortedFileEntries.map((event: FileEntry) => {
        return (
          <FileEntryListItem
            fileEntry={event}
            key={`re-listitem-${event.guid}`}
          />
        );
      })}
    </List>
  );
}
